import { render } from "./Messenger.vue?vue&type=template&id=9c1b3308&scoped=true"
import script from "./Messenger.vue?vue&type=script&lang=js"
export * from "./Messenger.vue?vue&type=script&lang=js"

import "./Messenger.vue?vue&type=style&index=0&id=9c1b3308&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c1b3308"]])

export default __exports__